export function assert(bool: false, message?: string): never;
export function assert(bool: boolean, message?: string) {
  if (!bool) {
    throw new Error(message || 'unknown assertion error');
  }
}
